import { t as Y, g as m, m as a, o as r, f as J, h as V } from "./color-scale-utils-38aedd61.mjs";
import { T as It, j as Ht, l as Gt, n as Vt, p as Nt, q as Ut, s as Zt, d as _t, u as zt, v as Wt, M as jt, C as $t, w as Kt, N as Jt, O as qt, P as Xt, Q as Qt, R as Yt, x as eo, y as so, S as to, z as oo, A as no, B as io, D as ro, E as ao, F as ho, G as co, H as mo, K as lo, I as po, J as Co, L as uo } from "./color-scale-utils-38aedd61.mjs";
import { i as go } from "./index-ec554115.mjs";
import { ChartModel as Re, ChartModelCartesian as Te, AlluvialChartModel as be, BoxplotChartModel as Oe, BulletChartModel as Se, ChoroplethModel as fe, CirclePackChartModel as Ae, PieChartModel as xe, GaugeChartModel as ye, HeatmapModel as De, ChartModelBinned as Fe, MeterChartModel as Le, RadarChartModel as Pe, TreeChartModel as Me, TreemapChartModel as ke, WordCloudModel as Be } from "./model/index.mjs";
import { _ as j, r as i, q as c, L as Z, y as A, t as N, e as $, S as Ie, u as K, F as p, l as R } from "./enums-a96ef472.mjs";
import { A as Eo, a as Ro, b as To, c as bo, d as Oo, f as So, B as fo, g as Ao, C as xo, h as yo, i as Do, j as Fo, k as Lo, m as Po, n as Mo, D as ko, o as Bo, G as Io, p as Ho, s as Go, v as Vo, M as No, w as Uo, P as Zo, x as _o, R as zo, z as Wo, H as jo, T as $o, I as Ko, J as Jo, K as qo, N as Xo, O as Qo, Q as Yo, U as en, V as sn, W as tn, Z as on, X as nn, Y as rn } from "./enums-a96ef472.mjs";
import { c as He, L as ee, C as Ge, T as _, a as z, b as g, S as F, d as se, M as W, e as Ve, f as Ne, g as Ue, H as Ze, Z as _e, A as te, h as ze, i as d, G as w, R as B, j as k, k as oe, l as M, m as C, B as We, n as I, o as je, p as $e, q as ne, r as Ke, s as Je, t as ie, u as re, v as U, w as ae, x as he, y as ce, P as qe, D as Xe, z as Qe, E as Ye, F as es, I as ss, J as ts, K as os, N as ns, O as is, Q as rs, U as as, V as hs, W as cs } from "./choropleth-91db5841.mjs";
import { X as hn, a8 as cn, a9 as mn, a7 as ln, Y as pn, _ as dn, $ as Cn, a0 as un, a1 as vn, a2 as gn, a3 as wn, a4 as En, a5 as Rn, a6 as Tn } from "./choropleth-91db5841.mjs";
import { C as ms, E as ls, F as ps, T as ds, a as Cs, b as us, Z as vs, f as gs } from "./index-fcba6cd5.mjs";
import { D as ws, G as Es } from "./angle-utils-a4fbf1b8.mjs";
import { S as On, d as Sn, a as fn, p as An, b as xn, r as yn } from "./angle-utils-a4fbf1b8.mjs";
import "d3";
import "./index-becfb567.mjs";
import "./a11y-7bad4f48.mjs";
import "./_baseEach-81f85d61.mjs";
import "d3-sankey";
import "d3-cloud";
function Rs(t, e, s) {
  var o = -1, n = t.length;
  e < 0 && (e = -e > n ? 0 : n + e), s = s > n ? n : s, s < 0 && (s += n), n = e > s ? 0 : s - e >>> 0, e >>>= 0;
  for (var h = Array(n); ++o < n; )
    h[o] = t[o + e];
  return h;
}
function Ts(t, e, s) {
  var o = t.length;
  return s = s === void 0 ? o : s, !e && s >= o ? t : Rs(t, e, s);
}
var bs = "\\ud800-\\udfff", Os = "\\u0300-\\u036f", Ss = "\\ufe20-\\ufe2f", fs = "\\u20d0-\\u20ff", As = Os + Ss + fs, xs = "\\ufe0e\\ufe0f", ys = "\\u200d", Ds = RegExp("[" + ys + bs + As + xs + "]");
function me(t) {
  return Ds.test(t);
}
function Fs(t) {
  return t.split("");
}
var le = "\\ud800-\\udfff", Ls = "\\u0300-\\u036f", Ps = "\\ufe20-\\ufe2f", Ms = "\\u20d0-\\u20ff", ks = Ls + Ps + Ms, Bs = "\\ufe0e\\ufe0f", Is = "[" + le + "]", q = "[" + ks + "]", X = "\\ud83c[\\udffb-\\udfff]", Hs = "(?:" + q + "|" + X + ")", pe = "[^" + le + "]", de = "(?:\\ud83c[\\udde6-\\uddff]){2}", Ce = "[\\ud800-\\udbff][\\udc00-\\udfff]", Gs = "\\u200d", ue = Hs + "?", ve = "[" + Bs + "]?", Vs = "(?:" + Gs + "(?:" + [pe, de, Ce].join("|") + ")" + ve + ue + ")*", Ns = ve + ue + Vs, Us = "(?:" + [pe + q + "?", q, de, Ce, Is].join("|") + ")", Zs = RegExp(X + "(?=" + X + ")|" + Us + Ns, "g");
function _s(t) {
  return t.match(Zs) || [];
}
function zs(t) {
  return me(t) ? _s(t) : Fs(t);
}
function Ws(t) {
  return function(e) {
    e = Y(e);
    var s = me(e) ? zs(e) : void 0, o = s ? s[0] : e.charAt(0), n = s ? Ts(s, 1).join("") : e.slice(1);
    return o[t]() + n;
  };
}
var js = Ws("toUpperCase");
const $s = js;
function Ks(t) {
  return $s(Y(t).toLowerCase());
}
var Js = He(function(t, e, s) {
  return e = e.toLowerCase(), t + (s ? Ks(e) : e);
});
const qs = Js;
class T {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor(e, s) {
    this.components = [], this.services = {
      canvasZoom: ms,
      domUtils: ws,
      events: ls,
      files: ps,
      gradientUtils: Es,
      transitions: ds
    }, this.model = new Re(this.services);
  }
  // Contains the code that uses properties that are overridable by the super-class
  init(e, s) {
    this.model.set({ holder: e }, { skipUpdate: !0 }), Object.keys(this.services).forEach((o) => {
      const n = this.services[o];
      this.services[o] = new n(this.model, this.services);
    }), this.services.events.addEventListener(j.Model.UPDATE, () => {
      this.update();
    }), this.model.setData(s.data), this.services.events.addEventListener(j.Chart.RESIZE, () => {
      this.update();
    }), this.components = this.getComponents(), this.update();
  }
  getComponents() {
    return console.error("getComponents() method is not implemented"), [];
  }
  update() {
    if (!this.components)
      return;
    Object.keys(this.services).forEach((o) => {
      this.services[o].update();
    }), this.components.forEach((o) => o.render(!0));
    const e = this.services.transitions.getPendingTransitions(), s = Object.keys(e).map((o) => e[o].end().catch((h) => h));
    Promise.all(s).then(
      () => this.services.events.dispatchEvent(j.Chart.RENDER_FINISHED)
    );
  }
  destroy() {
    this.components.forEach((e) => e.destroy()), this.services.domUtils.getHolder().remove(), this.model.set({ destroyed: !0 }, { skipUpdate: !0 });
  }
  getChartComponents(e, s) {
    const o = this.model.getOptions(), n = m(o, "toolbar", "enabled"), h = {
      id: "legend",
      components: [new ee(this.model, this.services)],
      growth: i.PREFERRED
    }, l = m(o, "canvasZoom", "enabled");
    l && l === !0 && e.push(new Ge(this.model, this.services));
    const b = !!this.model.getOptions().title, O = {
      id: "title",
      components: [new _(this.model, this.services)],
      growth: i.STRETCH
    }, x = {
      id: "toolbar",
      components: [new z(this.model, this.services)],
      growth: i.PREFERRED
    }, L = {
      id: "header",
      components: [
        new g(
          this.model,
          this.services,
          [
            // always add title to keep layout correct
            O,
            ...n ? [x] : []
          ],
          {
            direction: c.ROW,
            alignItems: Z.CENTER
          }
        )
      ],
      growth: i.PREFERRED
    }, y = {
      id: "graph-frame",
      components: e,
      growth: i.STRETCH,
      renderType: m(s, "graphFrameRenderType") || A.SVG
    }, D = m(s, "excludeLegend") !== !0 && o.legend.enabled !== !1;
    let S = c.COLUMN;
    if (D) {
      const f = m(o, "legend", "position");
      f === "left" ? (S = c.ROW, o.legend.orientation || (o.legend.orientation = N.VERTICAL)) : f === "right" ? (S = c.ROW_REVERSE, o.legend.orientation || (o.legend.orientation = N.VERTICAL)) : f === "bottom" && (S = c.COLUMN_REVERSE);
    }
    const P = {
      id: "spacer",
      components: [new F(this.model, this.services)],
      growth: i.PREFERRED
    }, v = {
      id: "full-frame",
      components: [
        new g(
          this.model,
          this.services,
          [
            ...D ? [h] : [],
            ...D ? [P] : [],
            y
          ],
          {
            direction: S
          }
        )
      ],
      growth: i.STRETCH
    }, E = [];
    if (b || n) {
      E.push(L);
      const f = {
        id: "spacer",
        components: [
          new F(this.model, this.services, n ? { size: 15 } : void 0)
        ],
        growth: i.PREFERRED
      };
      E.push(f);
    }
    return E.push(v), [
      new se(this.model, this.services),
      new W(this.model, this.services),
      new g(this.model, this.services, E, {
        direction: c.COLUMN
      })
    ];
  }
}
class u extends T {
  constructor(e, s) {
    super(e, s), this.services = Object.assign(this.services, {
      cartesianScales: Cs,
      curves: us,
      zoom: vs
    }), this.model = new Te(this.services);
  }
  getAxisChartComponents(e, s) {
    const o = this.model.getOptions(), n = m(o, "zoomBar", $.TOP, "enabled"), h = m(o, "toolbar", "enabled");
    this.services.cartesianScales.determineAxisDuality(), this.services.cartesianScales.findDomainAndRangeAxes(), this.services.cartesianScales.determineOrientation();
    const l = this.services.cartesianScales.getMainXAxisPosition(), b = m(o, "axes", l, "scaleType"), O = n && l === $.BOTTOM && b === Ie.TIME, x = this.services.zoom.isZoomBarLocked($.TOP), L = !!this.model.getOptions().title, y = {
      id: "title",
      components: [new _(this.model, this.services)],
      growth: i.STRETCH
    }, D = {
      id: "toolbar",
      components: [new z(this.model, this.services)],
      growth: i.PREFERRED
    }, S = {
      id: "header",
      components: [
        new g(
          this.model,
          this.services,
          [
            // always add title to keep layout correct
            y,
            ...h ? [D] : []
          ],
          {
            direction: c.ROW,
            alignItems: Z.CENTER
          }
        )
      ],
      growth: i.PREFERRED
    }, P = {
      id: "legend",
      components: [new ee(this.model, this.services)],
      growth: i.PREFERRED
    };
    O && !x && e.push(
      new Ve(this.model, this.services),
      new Ne(this.model, this.services)
    ), e.push(new Ue(this.model, this.services)), e.push(new Ze(this.model, this.services));
    const v = {
      id: "graph-frame",
      components: e,
      growth: i.STRETCH,
      renderType: A.SVG
    }, E = m(s, "legend", "enabled") !== !1 && this.model.getOptions().legend.enabled !== !1;
    let f = c.COLUMN;
    if (E) {
      const G = m(this.model.getOptions(), "legend", "position");
      G === K.LEFT ? (f = c.ROW, this.model.getOptions().legend.orientation || (this.model.getOptions().legend.orientation = N.VERTICAL)) : G === K.RIGHT ? (f = c.ROW_REVERSE, this.model.getOptions().legend.orientation || (this.model.getOptions().legend.orientation = N.VERTICAL)) : G === K.BOTTOM && (f = c.COLUMN_REVERSE);
    }
    const ge = {
      id: "spacer",
      components: [new F(this.model, this.services)],
      growth: i.PREFERRED
    }, we = {
      id: "full-frame",
      components: [
        new g(
          this.model,
          this.services,
          [
            ...E ? [P] : [],
            ...E ? [ge] : [],
            v
          ],
          {
            direction: f
          }
        )
      ],
      growth: i.STRETCH
    }, Ee = {
      id: "zoom-bar",
      components: [new _e(this.model, this.services)],
      growth: i.PREFERRED,
      renderType: A.SVG
    }, H = [];
    if (L || h) {
      H.push(S);
      const G = {
        id: "spacer",
        components: [
          new F(this.model, this.services, h ? { size: 15 } : void 0)
        ],
        growth: i.PREFERRED
      };
      H.push(G);
    }
    return O && H.push(Ee), H.push(we), [
      new te(this.model, this.services),
      new W(this.model, this.services),
      new g(this.model, this.services, H, {
        direction: c.COLUMN
      })
    ];
  }
}
class mt extends T {
  constructor(e, s) {
    super(e, s), this.model = new be(this.services), this.model.setOptions(a(r.alluvialChart, s.options)), this.init(e, s);
  }
  getComponents() {
    const e = [new ze(this.model, this.services)];
    return this.getChartComponents(e, {
      excludeLegend: !0
    });
  }
}
class lt extends u {
  constructor(e, s) {
    super(e, s), this.model.setOptions(a(J(r.areaChart), s.options)), this.init(e, s);
  }
  getComponents() {
    const e = [
      new d(this.model, this.services),
      new w(this.model, this.services),
      new B(this.model, this.services),
      new k(this.model, this.services),
      new oe(this.model, this.services),
      new M(this.model, this.services, {
        fadeInOnChartHolderMouseover: !0,
        handleThresholds: !0
      }),
      new C(this.model, this.services, {
        skeleton: p.GRID
      })
    ];
    return this.getAxisChartComponents(e);
  }
}
class pt extends u {
  constructor(e, s) {
    super(e, s), this.model = new Oe(this.services), this.model.setOptions(a(r.boxplotChart, s.options)), this.init(e, s);
  }
  getComponents() {
    const e = [
      new d(this.model, this.services),
      new w(this.model, this.services),
      new We(this.model, this.services),
      new I(this.model, this.services),
      new C(this.model, this.services, {
        skeleton: p.VERT_OR_HORIZ
      })
    ];
    return this.getAxisChartComponents(e, {
      legend: {
        enabled: !1
      }
    });
  }
}
class dt extends u {
  constructor(e, s) {
    super(e, s), this.model.setOptions(a(r.bubbleChart, s.options)), this.init(e, s);
  }
  getComponents() {
    const e = [
      new d(this.model, this.services),
      new w(this.model, this.services),
      new B(this.model, this.services),
      new je(this.model, this.services),
      new C(this.model, this.services, {
        skeleton: p.GRID
      })
    ];
    return this.getAxisChartComponents(e);
  }
}
class Ct extends u {
  constructor(e, s) {
    super(e, s), this.model = new Se(this.services), this.model.setOptions(a(r.bulletChart, s.options)), this.init(e, s);
  }
  getComponents() {
    const e = [
      new d(this.model, this.services),
      new w(this.model, this.services),
      new $e(this.model, this.services),
      new C(this.model, this.services, {
        skeleton: p.GRID
      })
    ];
    return this.getAxisChartComponents(e);
  }
}
class ut extends T {
  constructor(e, s) {
    super(e, s), this.model = new fe(this.services), this.model.setOptions(
      a(r.choroplethChart, s.options)
    ), this.init(e, s);
  }
  // Custom getChartComponents - Implements getChartComponents
  // Removes zoombar support and additional `features` that are not supported in heatmap
  getChartComponents(e, s) {
    const o = this.model.getOptions(), n = m(o, "toolbar", "enabled"), h = !!this.model.getOptions().title, l = {
      id: "title",
      components: [new _(this.model, this.services)],
      growth: i.STRETCH
    }, b = {
      id: "toolbar",
      components: [new z(this.model, this.services)],
      growth: i.PREFERRED
    }, O = {
      id: "header",
      components: [
        new g(
          this.model,
          this.services,
          [
            // always add title to keep layout correct
            l,
            ...n ? [b] : []
          ],
          {
            direction: c.ROW,
            alignItems: Z.CENTER
          }
        )
      ],
      growth: i.PREFERRED
    }, x = {
      id: "legend",
      components: [
        new ne(this.model, this.services, {
          chartType: "choropleth"
        })
      ],
      growth: i.PREFERRED,
      renderType: A.SVG
    }, L = {
      id: "graph-frame",
      components: e,
      growth: i.STRETCH,
      renderType: A.SVG
    }, y = m(s, "legend", "enabled") !== !1 && this.model.getOptions().legend.enabled !== !1, D = c.COLUMN_REVERSE, S = {
      id: "spacer",
      components: [new F(this.model, this.services, { size: 15 })],
      growth: i.PREFERRED
    }, P = {
      id: "full-frame",
      components: [
        new g(
          this.model,
          this.services,
          [
            ...y ? [x] : [],
            ...y ? [S] : [],
            L
          ],
          {
            direction: D
          }
        )
      ],
      growth: i.STRETCH
    }, v = [];
    if (h || n) {
      v.push(O);
      const E = {
        id: "spacer",
        components: [
          new F(this.model, this.services, n ? { size: 15 } : void 0)
        ],
        growth: i.PREFERRED
      };
      v.push(E);
    }
    return v.push(P), [
      new se(this.model, this.services),
      new W(this.model, this.services),
      new g(this.model, this.services, v, {
        direction: c.COLUMN
      })
    ];
  }
  getComponents() {
    const e = [new Ke(this.model, this.services)];
    return this.getChartComponents(e);
  }
}
class vt extends T {
  constructor(e, s) {
    super(e, s), this.model = new Ae(this.services), this.model.setOptions(a(r.circlePackChart, s.options)), this.init(e, s);
  }
  getComponents() {
    const e = [new Je(this.model, this.services)];
    return this.getChartComponents(e);
  }
}
const Q = {
  [R.LINE]: [k, M],
  [R.SCATTER]: [M],
  [R.AREA]: [oe, k, M],
  [R.STACKED_AREA]: [ie, k, re, U],
  [R.SIMPLE_BAR]: [ae],
  [R.GROUPED_BAR]: [he, I],
  [R.STACKED_BAR]: [ce, U]
};
class gt extends u {
  constructor(e, s) {
    super(e, s);
    const o = a(r.comboChart, s.options);
    s.options.comboChartTypes || (console.error("No comboChartTypes defined for the Combo Chart!"), o.comboChartTypes = [{ type: R.LINE, correspondingDatasets: [] }]), this.model.setOptions(o), this.init(e, s);
  }
  getGraphComponents() {
    const { comboChartTypes: e } = this.model.getOptions();
    let s = 0;
    const o = e.map((n) => {
      const h = n.type;
      let l;
      if (typeof n.type == "string") {
        if (!Object.keys(Q).includes(n.type))
          return console.error(
            `Invalid chart type "${n.type}" specified for combo chart. Please refer to the ComboChart tutorial for more guidance.`
          ), null;
        let b = !1;
        const O = `${qs(n.type)}Chart`;
        return l = V(
          {},
          r[O],
          this.model.getOptions(),
          n.options
        ), n.type === R.STACKED_AREA && (b = !0), Q[n.type].map(
          (x) => new x(this.model, this.services, {
            groups: n.correspondingDatasets,
            id: s++,
            options: l,
            stacked: b
          })
        );
      } else
        return l = V({}, this.model.getOptions(), n.options), new h(this.model, this.services, {
          groups: n.correspondingDatasets,
          id: s++,
          options: l
        });
    }).filter((n) => n !== null);
    return gs(o);
  }
  getComponents() {
    const { comboChartTypes: e } = this.model.getOptions(), s = e.some(
      (h) => h.type === R.STACKED_BAR || h.type === R.STACKED_AREA
    ), o = [
      new d(this.model, this.services),
      new w(this.model, this.services),
      new C(this.model, this.services, {
        skeleton: p.GRID
      }),
      ...s ? [] : [new B(this.model, this.services)],
      ...this.getGraphComponents()
    ];
    return this.getAxisChartComponents(o);
  }
}
class Xs extends T {
  // TODO - Optimize the use of "extending"
  constructor(e, s, o = !1) {
    super(e, s), this.model = new xe(this.services), !o && (this.model.setOptions(a(r.pieChart, s.options)), this.init(e, s));
  }
  getComponents() {
    const e = [
      new qe(this.model, this.services),
      new C(this.model, this.services, {
        skeleton: p.PIE
      })
    ];
    return this.getChartComponents(e);
  }
}
class wt extends Xs {
  constructor(e, s) {
    super(e, s, !0), this.model.setOptions(a(r.donutChart, s.options)), this.init(e, s);
  }
  getComponents() {
    const e = [
      new Xe(this.model, this.services),
      new C(this.model, this.services, {
        skeleton: p.DONUT
      })
    ];
    return this.getChartComponents(e);
  }
}
class Et extends T {
  constructor(e, s) {
    super(e, s), this.model = new ye(this.services), this.model.setOptions(a(r.gaugeChart, s.options)), this.init(e, s);
  }
  getComponents() {
    const e = [new Qe(this.model, this.services)];
    return this.getChartComponents(e);
  }
}
class Rt extends u {
  constructor(e, s) {
    super(e, s), this.model.setOptions(a(r.groupedBarChart, s.options)), this.init(e, s);
  }
  getComponents() {
    const e = [
      new d(this.model, this.services),
      new w(this.model, this.services),
      new he(this.model, this.services),
      new I(this.model, this.services),
      new C(this.model, this.services, {
        skeleton: p.VERT_OR_HORIZ
      })
    ];
    return this.getAxisChartComponents(e);
  }
}
class Tt extends u {
  constructor(e, s) {
    super(e, s), this.model = new De(this.services), this.model.setOptions(a(r.heatmapChart, s.options)), this.init(e, s);
  }
  // Custom getChartComponents - Implements getChartComponents
  // Removes zoombar support and additional `features` that are not supported in heatmap
  getAxisChartComponents(e, s) {
    const o = this.model.getOptions(), n = m(o, "toolbar", "enabled");
    this.services.cartesianScales.determineAxisDuality(), this.services.cartesianScales.findDomainAndRangeAxes(), this.services.cartesianScales.determineOrientation();
    const h = !!this.model.getOptions().title, l = {
      id: "title",
      components: [new _(this.model, this.services)],
      growth: i.STRETCH
    }, b = {
      id: "toolbar",
      components: [new z(this.model, this.services)],
      growth: i.PREFERRED
    }, O = {
      id: "header",
      components: [
        new g(
          this.model,
          this.services,
          [
            // always add title to keep layout correct
            l,
            ...n ? [b] : []
          ],
          {
            direction: c.ROW,
            alignItems: Z.CENTER
          }
        )
      ],
      growth: i.PREFERRED
    }, x = {
      id: "legend",
      components: [
        new ne(this.model, this.services, {
          chartType: "heatmap"
        })
      ],
      growth: i.PREFERRED,
      renderType: A.SVG
    }, L = {
      id: "graph-frame",
      components: e,
      growth: i.STRETCH,
      renderType: A.SVG
    }, y = m(s, "legend", "enabled") !== !1 && this.model.getOptions().legend.enabled !== !1, D = c.COLUMN_REVERSE, S = {
      id: "spacer",
      components: [new F(this.model, this.services, { size: 15 })],
      growth: i.PREFERRED
    }, P = {
      id: "full-frame",
      components: [
        new g(
          this.model,
          this.services,
          [
            ...y ? [x] : [],
            ...y ? [S] : [],
            L
          ],
          {
            direction: D
          }
        )
      ],
      growth: i.STRETCH
    }, v = [];
    if (h || n) {
      v.push(O);
      const E = {
        id: "spacer",
        components: [
          new F(this.model, this.services, n ? { size: 15 } : void 0)
        ],
        growth: i.PREFERRED
      };
      v.push(E);
    }
    return v.push(P), [
      new te(this.model, this.services),
      new W(this.model, this.services),
      new g(this.model, this.services, v, {
        direction: c.COLUMN
      })
    ];
  }
  getComponents() {
    const e = [
      new d(this.model, this.services),
      new Ye(this.model, this.services)
    ];
    return this.getAxisChartComponents(e);
  }
}
class bt extends u {
  constructor(e, s) {
    super(e, s), this.model = new Fe(this.services), this.model.setOptions(a(r.histogramChart, s.options)), this.init(e, s), this.update();
  }
  getComponents() {
    const e = [
      new d(this.model, this.services),
      new w(this.model, this.services),
      new es(this.model, this.services),
      new ss(this.model, this.services)
    ];
    return this.getAxisChartComponents(e);
  }
}
class Ot extends u {
  constructor(e, s) {
    super(e, s), this.model.setOptions(a(r.lineChart, s.options)), this.init(e, s);
  }
  getComponents() {
    const e = [
      new d(this.model, this.services),
      new w(this.model, this.services),
      new B(this.model, this.services),
      new k(this.model, this.services),
      new M(this.model, this.services, { handleThresholds: !0 }),
      new ts(this.model, this.services),
      new I(this.model, this.services)
    ];
    return this.getAxisChartComponents(e);
  }
}
class St extends u {
  constructor(e, s) {
    super(e, s), this.model.setOptions(a(r.lollipopChart, s.options)), this.init(e, s);
  }
  getComponents() {
    const e = [
      new d(this.model, this.services),
      new w(this.model, this.services),
      new B(this.model, this.services),
      new os(this.model, this.services),
      new M(this.model, this.services),
      new C(this.model, this.services, {
        skeleton: p.GRID
      })
    ];
    return this.getAxisChartComponents(e);
  }
}
class ft extends T {
  constructor(e, s) {
    var n;
    super(e, s), this.model = new Le(this.services);
    const o = (n = s.options.meter) != null && n.proportional ? V(J(r.proportionalMeterChart), s.options) : V(J(r.meterChart), s.options);
    this.model.setOptions(o), this.init(e, s);
  }
  getComponents() {
    const s = [
      ...m(this.model.getOptions(), "meter", "showLabels") ? [
        // Meter has a unique dataset title within the graph
        {
          id: "meter-title",
          components: [new ns(this.model, this.services)],
          growth: i.STRETCH,
          renderType: A.SVG
        },
        // Create the title spacer
        {
          id: "spacer",
          components: [
            new F(this.model, this.services, {
              size: 8
            })
          ],
          growth: i.STRETCH
        }
      ] : [],
      // Specify what to render inside the graph only
      {
        id: "meter-graph",
        components: [new is(this.model, this.services)],
        growth: i.STRETCH,
        renderType: A.SVG
      }
    ], o = [
      new g(this.model, this.services, s, {
        direction: c.COLUMN
      })
    ];
    return this.getChartComponents(o, {
      graphFrameRenderType: A.HTML
    });
  }
}
class At extends T {
  constructor(e, s) {
    super(e, s), this.model = new Pe(this.services), this.model.setOptions(a(r.radarChart, s.options)), this.init(e, s);
  }
  getComponents() {
    const e = [new rs(this.model, this.services)];
    return this.getChartComponents(e);
  }
}
class xt extends u {
  constructor(e, s) {
    super(e, s), this.model.setOptions(a(r.scatterChart, s.options)), this.init(e, s);
  }
  getComponents() {
    const e = [
      new d(this.model, this.services),
      new w(this.model, this.services),
      new B(this.model, this.services),
      new M(this.model, this.services),
      new C(this.model, this.services, {
        skeleton: p.GRID
      })
    ];
    return this.getAxisChartComponents(e);
  }
}
class yt extends T {
  constructor(e, s) {
    super(e, s), this.model = new Me(this.services), this.model.setOptions(a(r.treeChart, s.options)), this.init(e, s);
  }
  getComponents() {
    const e = [new as(this.model, this.services)];
    return this.getChartComponents(e, {
      excludeLegend: !0
    });
  }
}
class Dt extends T {
  constructor(e, s) {
    super(e, s), this.model = new ke(this.services), this.model.setOptions(a(r.treemapChart, s.options)), this.init(e, s);
  }
  getComponents() {
    const e = [new hs(this.model, this.services)];
    return this.getChartComponents(e);
  }
}
class Ft extends u {
  constructor(e, s) {
    super(e, s), this.model.setOptions(a(r.simpleBarChart, s.options)), this.init(e, s);
  }
  getComponents() {
    const e = [
      new d(this.model, this.services),
      new w(this.model, this.services),
      new ae(this.model, this.services),
      new I(this.model, this.services),
      new C(this.model, this.services, {
        skeleton: p.VERT_OR_HORIZ
      })
    ];
    return this.getAxisChartComponents(e);
  }
}
class Lt extends u {
  constructor(e, s) {
    super(e, s), this.model.setOptions(a(r.stackedAreaChart, s.options)), this.init(e, s);
  }
  getComponents() {
    const e = [
      new d(this.model, this.services),
      new w(this.model, this.services),
      new U(this.model, this.services),
      new ie(this.model, this.services),
      new k(this.model, this.services, { stacked: !0 }),
      new re(this.model, this.services, {
        fadeInOnChartHolderMouseover: !0,
        handleThresholds: !0,
        stacked: !0
      }),
      new C(this.model, this.services, {
        skeleton: p.GRID
      })
    ];
    return this.getAxisChartComponents(e);
  }
}
class Pt extends u {
  constructor(e, s) {
    super(e, s), this.model.setOptions(a(r.stackedBarChart, s.options)), this.init(e, s);
  }
  getComponents() {
    const e = [
      new d(this.model, this.services),
      new w(this.model, this.services),
      new U(this.model, this.services),
      new ce(this.model, this.services),
      new C(this.model, this.services, {
        skeleton: p.VERT_OR_HORIZ
      }),
      new I(this.model, this.services)
    ];
    return this.getAxisChartComponents(e);
  }
}
class Mt extends T {
  constructor(e, s) {
    super(e, s), this.model = new Be(this.services), this.model.setOptions(a(r.wordCloudChart, s.options)), this.init(e, s);
  }
  getComponents() {
    const e = [
      new cs(this.model, this.services),
      new C(this.model, this.services, {
        skeleton: p.PIE
      })
    ];
    return this.getChartComponents(e);
  }
}
export {
  Eo as Alignments,
  ze as Alluvial,
  mt as AlluvialChart,
  be as AlluvialChartModel,
  oe as Area,
  lt as AreaChart,
  Ro as AreaEvent,
  To as ArrowDirections,
  hn as Axis,
  u as AxisChart,
  te as AxisChartsTooltip,
  bo as AxisEvent,
  Oo as AxisFlavor,
  $ as AxisPositions,
  So as AxisTitleOrientations,
  cn as Bar,
  fo as BarEvent,
  es as BinnedRuler,
  We as Boxplot,
  pt as BoxplotChart,
  Oe as BoxplotChartModel,
  Ao as BoxplotEvent,
  je as Bubble,
  dt as BubbleChart,
  $e as Bullet,
  Ct as BulletChart,
  Se as BulletChartModel,
  xo as CalloutDirections,
  Ge as CanvasChartClip,
  ms as CanvasZoom,
  yo as CanvasZoomEvent,
  Do as CartesianOrientations,
  Cs as CartesianScales,
  T as Chart,
  Ne as ChartBrush,
  Ve as ChartClip,
  Fo as ChartEvent,
  Re as ChartModel,
  Fe as ChartModelBinned,
  Te as ChartModelCartesian,
  Lo as ChartTheme,
  R as ChartTypes,
  Ke as Choropleth,
  fe as ChoroplethModel,
  Je as CirclePack,
  vt as CirclePackChart,
  Ae as CirclePackChartModel,
  Po as ColorClassNameTypes,
  Mo as ColorLegendType,
  ne as ColorScaleLegend,
  gt as ComboChart,
  mn as Component,
  us as Curves,
  ws as DOMUtils,
  ko as DividerStatus,
  Bo as DominantBaseline,
  Xe as Donut,
  wt as DonutChart,
  ls as Events,
  ut as ExperimentalChoroplethChart,
  ps as Files,
  Qe as Gauge,
  Et as GaugeChart,
  ye as GaugeChartModel,
  Io as GaugeEvent,
  Ho as GaugeTypes,
  ln as GeoProjection,
  Es as GradientUtils,
  w as Grid,
  he as GroupedBar,
  Rt as GroupedBarChart,
  Ye as Heatmap,
  Tt as HeatmapChart,
  De as HeatmapModel,
  Ze as Highlight,
  ss as Histogram,
  bt as HistogramChart,
  pn as HoverAxis,
  Z as LayoutAlignItems,
  g as LayoutComponent,
  c as LayoutDirection,
  i as LayoutGrowth,
  ee as Legend,
  Go as LegendItemType,
  N as LegendOrientations,
  K as LegendPositions,
  k as Line,
  Ot as LineChart,
  Vo as LineEvent,
  os as Lollipop,
  St as LollipopChart,
  is as Meter,
  ft as MeterChart,
  Le as MeterChartModel,
  ns as MeterTitle,
  W as Modal,
  No as ModalEvent,
  Uo as ModelEvent,
  qe as Pie,
  Xs as PieChart,
  xe as PieChartModel,
  Zo as PieEvent,
  _o as Projection,
  rs as Radar,
  At as RadarChart,
  Pe as RadarChartModel,
  zo as RadarEvent,
  A as RenderTypes,
  B as Ruler,
  Ie as ScaleTypes,
  M as Scatter,
  xt as ScatterChart,
  Wo as ScatterEvent,
  On as Service,
  ae as SimpleBar,
  Ft as SimpleBarChart,
  C as Skeleton,
  ts as SkeletonLines,
  p as Skeletons,
  F as Spacer,
  ie as StackedArea,
  Lt as StackedAreaChart,
  ce as StackedBar,
  Pt as StackedBarChart,
  U as StackedRuler,
  re as StackedScatter,
  jo as Statuses,
  It as TIME_INTERVALS,
  $o as TextAnchor,
  Ue as Threshold,
  Ko as ThresholdEvent,
  Jo as TickRotations,
  _ as Title,
  z as Toolbar,
  qo as ToolbarControlTypes,
  se as Tooltip,
  Xo as TooltipEvent,
  ds as Transitions,
  as as Tree,
  yt as TreeChart,
  Me as TreeChartModel,
  Qo as TreeEvent,
  Yo as TreeTypes,
  hs as Treemap,
  Dt as TreemapChart,
  ke as TreemapChartModel,
  en as TreemapEvent,
  sn as TruncationTypes,
  d as TwoDimensionalAxes,
  cs as WordCloud,
  Mt as WordCloudChart,
  tn as WordCloudEvent,
  Be as WordCloudModel,
  I as ZeroLine,
  vs as Zoom,
  _e as ZoomBar,
  on as ZoomBarTypes,
  nn as ZoomDomainEvent,
  rn as ZoombarEvent,
  Ht as alluvial,
  Gt as area,
  dn as arrowLeft,
  Cn as arrowRight,
  Vt as axis,
  Nt as baseTooltip,
  Ut as boxplot,
  un as buildBezierPathString,
  vn as buildElbowPathString,
  gn as buildStraightPathString,
  Zt as canvasZoomSettings,
  _t as carbonPrefix,
  wn as circle,
  zt as circlePack,
  Wt as color,
  jt as computeTimeIntervalName,
  $t as configurations,
  Kt as defaultLegendAdditionalItems,
  Sn as degToRad,
  En as diamond,
  fn as distanceBetweenPointOnCircAndVerticalDiameter,
  Jt as formatDateTillMilliSeconds,
  qt as formatTick,
  Xt as getColorScale,
  Qt as getDomain,
  Yt as getTimeformats,
  eo as grid,
  so as histogram,
  go as interfaces,
  to as isTickPrimary,
  oo as legend,
  no as lines,
  io as meter,
  r as options,
  ro as pie,
  An as polarToCartesianCoords,
  xn as radToDeg,
  ao as radar,
  yn as radialLabelPlacement,
  ho as ruler,
  co as spacers,
  Rn as square,
  Tn as tee,
  mo as timeScale,
  lo as toolbar,
  po as tooltips,
  Co as transitions,
  uo as zoomBar
};
//# sourceMappingURL=index.mjs.map
